<template>
  <div>
    <b-container>
      <h2>Twitter Hashtag Reports</h2>
      <p>Order a comprehensive report for 100% of any hashtag's usage, audience, sentiment and much more.</p>
      <b-row>
        <b-col class="col-md-5">
          <b-input-group size="md">
            <b-input-group-text slot="prepend">#</b-input-group-text>

            <b-form-input v-model="selectedHashtag" class="hashtag-input" @keyup.enter="goToHashtagStats" />

            <b-input-group-append>
              <b-btn ref="selectHashtagBtn" variant="primary" :href="hashtagUrl">Continue</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <span class="align-top">or</span>
        <b-col class="col-md-3 text-left">
          <b-btn
            variant="outline-primary"
            href="https://ritetag.com/hashtag-stats/TNW2019?uuid=4073be07-a7ac-4559-9fde-a31e92e9e211"
          >
            <i class="far fa-file-alt"></i> View sample report
          </b-btn>
        </b-col>
      </b-row>
      <br>
      <br>
      <h5>Purchased Reports</h5>
      <div class="hashtag-reports-spinner" v-if="dataLoaded === false">
        <font-awesome-icon :icon="['fas', 'spinner']" class="fa-spin text-muted"/><br>
      </div>
      <b-table
        v-if="reportData.length > 0"
        :items="reportData"
        :fields="reportTableFields"
        data-show-header="false"
        class="hide-header vertical-align-middle"
        :responsive="true"
      >
        <template v-slot:cell(hashtag)="data">
          <strong>
            <a v-bind:href="data.item.link" v-if="data.item.status === 'done'">#{{ data.item.hashtag }}</a>
            <span v-else>#{{ data.item.hashtag }}</span>
           </strong>
        </template>
        <template v-slot:cell(time_interval)="data">
           {{ data.item.start | formatToShortDate }} - {{ data.item.end | formatToShortDate }}
        </template>
        <template v-slot:cell(status)="data">
          <b-badge pill variant="success" v-if="data.item.status=='done'">
            {{ data.item.status | capitalize }}
          </b-badge>
          <b-badge pill variant="warning" v-else>
            {{ data.item.status | capitalize }}
          </b-badge>
        </template>
        <template  v-slot:cell(publish)="data">
          <div class="text-right">
            <b-btn
              v-if="!data.item.published && data.item.status == 'done'"
              variant="outline-primary"
              v-b-tooltip="'Make this report shareable by URL. Anyone who clicks the link can view and use all of it, even without a RiteTag account. (Cannot be undone)'"
              v-on:click="publishReport(data.item.uuid)"
            >Publish
            </b-btn>
            <b-btn
              v-if="data.item.published && data.item.status == 'done'"
              variant="outline-secondary"
              v-on:click="data.toggleDetails"
            >{{ data.detailsShowing ? 'Hide' : 'Show' }} link
            </b-btn>
            &nbsp;
            <a class="btn btn-primary" v-bind:href="data.item.link" v-if="data.item.status=='done'">View report</a>
          </div>
        </template>
        <template v-slot:cell(row-details)="data">
            <b-form-input
              type="text"
              class="link-input"
              v-bind:value="'https://ritetag.com/hashtag-stats/' + data.item.hashtag + '?uuid=' + data.item.uuid"
            ></b-form-input>
        </template>
      </b-table>
    </b-container>

  </div>
</template>

<script>
  import {api} from "../_services"

export default {
  name: 'HashtagReports',
  data() {
    return {
      selectedHashtag: '',
      hashtagUrl: '',
      reportTableFields: [
        'hashtag',
        'time_interval',
        'price',
        'status',
        { key: 'publish', label: ''}
      ],
      reportData: [],
      dataLoaded: false
    }
  },
  methods: {
    publishReport: function(uuid) {
      api.publishReport(uuid)
        .then(response => {
          // todo
        })
        .catch(err => {
          // todo
        })
    },
    goToHashtagStats: function() {
      if (this.selectedHashtag) {
        this.$refs.selectHashtagBtn.click()
      }
    }
  },
  watch: {
    selectedHashtag: function () {
      this.hashtagUrl = `${process.env.RITETAG_URL}/hashtag-stats/` + this.selectedHashtag
    }
  },
  beforeCreate() {
    api.hashtagReports()
      .then(response => {
        const res = response.data.data
        this.reportData = res
        this.dataLoaded = true
      })
      .catch(err => {
        console.log(error)
        //todo
      })
  }
}
</script>

<style scoped>

.align-top {
  padding-top: 5px;
}

.hashtag-input {
  height: auto;
}

.link-input {
  width: 100%;
}

.hashtag-reports-spinner {
  text-align: center;
  padding: 60px 0px;
  font-size: 2rem;
}
</style>
